<template>
    <div :class="'header__top_account'">
        <div class="header__top_account_inner">
            <div class="columns fullheight is-variable is-2">
                <template v-if="allowTopAccountNav">
                    <div :class="[
                        'column',
                        'column--custom-nav'
                    ]">
                        <div class="columns is-variable is-6">
                            <div class="column">
                                <header-top-account-nav
                                    :class="[
                                        hamburgerMenuActive ? 'header__top_account_nav--active' : 'header__top_account_nav--inactive',
                                        hamburgerMenuTouched && allowTopAccountNav ? 'header__top_account_nav--touched' : ''
                                    ]"
                                ></header-top-account-nav>
                            </div>
                        </div>
                    </div>
                    <div class="column is-narrow column--custom-actions">
                        <div class="columns is-vcentered is-variable is-3">
                            <div class="column is-narrow">
                                <header-top-account-menu/>
                            </div>
                            <div class="column is-narrow"></div>
                            <template v-if="user.isTokenFromNewLms()">
                                <div class="column is-narrow">
                                    <header-top-account-dots-button data-v-step="3"/>
                                </div>
                            </template>
                        </div>
                    </div>
                </template>
                <template v-if="!allowTopAccountNav && !$route.meta.hideAuthLogin">
                    <div class="column"></div>
                    <div class="column has-text-right is-narrow">
                        <header-top-account-login/>
                    </div>
                    <template v-if="false">
                        <div class="column"></div>
                        <div class="column is-narrow">
                            <header-top-account-signup/>
                        </div>
                    </template>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import HeaderTopAccountNav from '@/components/default/layout/header/HeaderTopAccountNav'
import HeaderTopAccountMenu from '@/components/default/layout/header/HeaderTopAccountMenu'
import HeaderTopAccountLogin from '@/components/default/layout/header/HeaderTopAccountLogin'
import HeaderTopAccountSignup from '@/components/default/layout/header/HeaderTopAccountSignup'
import { User } from '@/User'
import HeaderTopAccountDotsButton from '@/components/default/layout/header/HeaderTopAccountDotsButton'

export default {
  name: 'header-top-account',
  data () {
    return {
      user: new User()
    }
  },
  components: { HeaderTopAccountDotsButton, HeaderTopAccountSignup, HeaderTopAccountLogin, HeaderTopAccountMenu, HeaderTopAccountNav },
  props: {
    hamburgerMenuActive: {
      type: Boolean
    },
    hamburgerMenuTouched: {
      type: Boolean
    }
  },
  computed: {
    allowTopAccountNav () {
      const firstStageToken = this.$store.getters.getAuthUserFirstStageTokenData
      const secondStageToken = this.$store.getters.getAuthUserSecondStageTokenData
      const isSecondStageTokenFromOldLMS = this.user.isTokenFromOldLms()
      const isFromSSO = this.user.isTokenFromSSO()
      const routeName = this.$route.name

      if (!routeName) return

      return (
        firstStageToken ||
      (
        secondStageToken &&
      (isSecondStageTokenFromOldLMS || isFromSSO)
      )
      )
    },
    checkIsInvitation () {
      return Boolean(this.$store.getters.getAuthUserSignUpInvitation)
    }
  }
}
</script>
